import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { areUserRolesIn } from '../helpers';
import { Roles, BTSessionStatus } from '../constants';
import { CQAReviewStatus } from '../components/layout/qa/constants';

import type { RootState } from '../store';

function useSessionEditable(isBay7InPersonGuardianFlow: boolean) {
  const { user } = useSelector((state: RootState) => state.auth);
  const { current: session } = useSelector((state: RootState) => state.sessions);
  const [isEditable, setIsEditable] = useState<boolean>(false);

  useEffect(() => {
    const sessionProvider = session?.session_provider;
    if (
      // Only VBT abd PRBTs are allowed to edit a session
      (!areUserRolesIn(user?.roles, [Roles.Prbt, Roles.Vbt, Roles.Bcba]) ||
        // Only the provider which created the session can edit the session
        (sessionProvider && user?.email !== sessionProvider.email) ||
        !session ||
        // Only sessions which are in Started or Edits Requested statuses can be edited
        (session &&
          session.status !== BTSessionStatus.Started &&
          session.status !== BTSessionStatus.EditsRequested) ||
        // Edits requested but not acknowledged sessions can't be edited
        (session.status === BTSessionStatus.EditsRequested &&
          session.clinical_qa_review?.status !== CQAReviewStatus.Acknowledged)) &&
      !(
        session?.status === BTSessionStatus.AwaitingGuardianSignature &&
        (areUserRolesIn(user?.roles, [Roles.Prbt]) ||
          (areUserRolesIn(user?.roles, [Roles.Vbt]) && isBay7InPersonGuardianFlow))
      )
    ) {
      setIsEditable(false);
    } else {
      setIsEditable(true);
    }
  }, [session]);

  return isEditable;
}

export default useSessionEditable;
